import { EnrollmentStatusFilter, RosterFilterKind, RosterGroupingKind } from 'app2/api';
import { Option } from 'app2/components';

import { useEnrollmentsFilterOptionsQuery } from '../generated';

export function useGroupOptions(params:{groupingId:string, groupingKind:RosterGroupingKind}) {
  const [result] = useEnrollmentsFilterOptionsQuery({ variables: { groupingId: params.groupingId, groupingKind:params.groupingKind, enrollmentStatus:EnrollmentStatusFilter.Rostered, filterKind:RosterFilterKind.Group } });
  return result.data ? Object.values(result.data)[0] as Option[] : [];
}
